import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, {
    style: {"width":"100%"},
    gutter: 2
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        span: 4,
        style: {"text-align":"left"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: _ctx.countryCode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.countryCode) = $event)),
            onChange: _ctx.onPhoneCodeChange
          }, {
            label: _withCtx((e) => [
              _createElementVNode("span", null, _toDisplayString(e.label) + " " + _toDisplayString(e.value), 1)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryCodes, (e) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: e.code,
                  label: e.label,
                  value: e.code
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(e.label) + " " + _toDisplayString(e.code), 1)
                  ]),
                  _: 2
                }, 1032, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 1 }),
      _createVNode(_component_el_col, { span: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phone) = $event)),
            maxlength: 12,
            minlength: 10
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}